import { render, staticRenderFns } from "./deadlock.vue?vue&type=template&id=2bb19b14&scoped=true"
import script from "./deadlock.vue?vue&type=script&lang=js"
export * from "./deadlock.vue?vue&type=script&lang=js"
import style0 from "./deadlock.vue?vue&type=style&index=0&id=2bb19b14&prod&lang=scss"
import style1 from "./deadlock.vue?vue&type=style&index=1&id=2bb19b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb19b14",
  null
  
)

export default component.exports